const storage: any = {
  upload: 'storage:upload',
};

export default storage;